import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Edit, Trash2 } from 'lucide-react';
import { LoadingState, EmptyState } from '@/components/shared';
import { Newspaper } from 'lucide-react';
import { PostsManagerViewProps } from './postsmanager.props';
import PostsFormDialog from './postsmanager.form';

const PostsManagerView: React.FC<PostsManagerViewProps> = ({
  postsList,
  loading,
  isDialogOpen,
  setIsDialogOpen,
  editingPost,
  setEditingPost,
  formData,
  setFormData,
  handleEdit,
  handleDelete,
  handleSubmit,
  deleteTarget,
  setDeleteTarget,
  confirmDelete,
}) => {
  return (
    <>
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle>Управување со постови</CardTitle>
            <PostsFormDialog
              isDialogOpen={isDialogOpen}
              setIsDialogOpen={setIsDialogOpen}
              editingPost={editingPost}
              setEditingPost={setEditingPost}
              formData={formData}
              setFormData={setFormData}
              handleSubmit={handleSubmit}
              deleteTarget={deleteTarget}
              setDeleteTarget={setDeleteTarget}
              confirmDelete={confirmDelete}
            />
          </div>
        </CardHeader>
        <CardContent>
          {loading ? (
            <LoadingState />
          ) : (
            <div className="space-y-4">
              {postsList.length === 0 ? (
                <EmptyState
                  icon={<Newspaper className="w-10 h-10 text-muted-foreground" />}
                  message="Нема креирано постови. Креирајте го вашиот прв пост."
                  action={{ label: 'Креирај пост', onClick: () => setIsDialogOpen(true) }}
                />
              ) : postsList.map((post) => (
                <div
                  key={post.id}
                  className="flex items-center justify-between p-4 border border-border rounded-lg hover:bg-muted transition-colors"
                >
                  <div className="flex items-center space-x-4">
                    <img src={post.image} alt={post.title} className="w-16 h-16 object-cover rounded" />
                    <div>
                      <h4 className="font-semibold text-foreground">{post.title}</h4>
                      <p className="text-sm text-muted-foreground line-clamp-2">{post.excerpt}</p>
                      <p className="text-xs text-muted-foreground mt-1">{post.publishDate ? new Date(post.publishDate).toLocaleDateString('mk-MK') : ''}</p>
                    </div>
                  </div>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => handleEdit(post)}>
                      <Edit className="w-4 h-4" />
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => handleDelete(post.id)}
                      className="text-red-600 hover:text-red-700 hover:bg-red-50"
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default PostsManagerView;
